import { operations } from "./schema";
export * from "./auth";
export * from "./client";
export * from "./messages";

export type ApiItem =
  operations["getApiItems"]["responses"]["200"]["content"]["application/json"]["items"][number];
export type ApiItemPackaging = ApiItem["packagings"][number];
export type ApiItemComponent = ApiItem["components"][number];

export type ApiOrder =
  operations["getApiOrders"]["responses"]["200"]["content"]["application/json"]["items"][number];
export type ApiOrderAddress = ApiOrder["facturation"];
export type ApiOrderItem = ApiOrder["items"][number];

export enum ApiOrderState {
  Loading = 0,
  Loaded = 10,
  Picked = 20,
  Missing = 30,
  Done = 50,
}

export const ApiOrderStateLabel = new Map<ApiOrderState, string>([
  [ApiOrderState.Loading, "En intégration"],
  [ApiOrderState.Loaded, "A faire"],
  [ApiOrderState.Picked, "Préparation"],
  [ApiOrderState.Missing, "Relicat"],
  [ApiOrderState.Done, "Terminé"],
]);

type ApiOrderQuery = NonNullable<
  operations["getApiOrders"]["parameters"]["query"]
>;
export type ApiOrderSortBy = ApiOrderQuery["sortBy"];
export type ApiOrderSortDir = ApiOrderQuery["sortDir"];

export type ApiOrg =
  operations["getApiOrgsByOrg"]["responses"]["200"]["content"]["application/json"];
export type ApiOrgItemType = ApiOrg["itemTypes"][number];
export type ApiOrgConfigCarrier = ApiOrg["config"]["carriers"][number];

export type ApiPicking =
  operations["getApiPickings"]["responses"]["200"]["content"]["application/json"]["items"][number];

export type ApiPickingItem =
  operations["getApiPickingsById"]["responses"]["200"]["content"]["application/json"]["items"][number];

export type ApiPickingItemOrder = ApiPickingItem["orders"][number];

export type ApiUser =
  operations["getApiUsers"]["responses"]["200"]["content"]["application/json"]["items"][number];

export type ApiSync =
  operations["getApiSyncs"]["responses"]["200"]["content"]["application/json"]["items"][number];
export type ApiSyncEventConfig = ApiSync["events"][number];
export type ApiSyncActionConfig = ApiSyncEventConfig["action"];
export type ApiSyncEventTypes = ApiSyncEventConfig["type"];

export enum ApiDouaneType {
  FULL = 1,
  RELATIVE = 2,
  DRM = 3,
}

export const ApiDouaneTypeLabel = new Map<ApiDouaneType, string>([
  [ApiDouaneType.FULL, "Inventaire"],
  [ApiDouaneType.RELATIVE, "Entrées"],
  [ApiDouaneType.DRM, "Déclaration"],
]);

export type ApiListDouane =
  operations["getApiDouanes"]["responses"]["200"]["content"]["application/json"]["items"][number];
export type ApiDouane =
  operations["getApiDouanesById"]["responses"]["200"]["content"]["application/json"];
export type ApiDouaneItem = ApiDouane["items"][number];
export type ApiDouaneDrmItem = ApiDouane["drmitems"][number];

export enum OrderStock {
  InStock,
  Reappro,
  Missing,
}
